export function Loader({ label = "Loading" }) {
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4">
      <div className="h-10 w-10 animate-spin rounded-full border-2 border-gold/30 border-t-gold" />
      <p className="font-mono text-[10px] uppercase tracking-widest text-[var(--aur-text-2)]">{label}</p>
    </div>
  );
}
